module.exports = __webpack_public_path__ + "public/img/bahasa-inggris-untuk-karyawan.66bb87c9.png";